import { render, staticRenderFns } from "./ContactsMenu.vue?vue&type=template&id=ca2f7026&"
import script from "./ContactsMenu.vue?vue&type=script&lang=js&"
export * from "./ContactsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports